import {useMemo} from 'react';
import FontAwesome from "../utilities/FontAwesome";
import {
    type UseVirtualFloatingOptions,
} from '@udecode/plate-floating';
import styles from "./styles/SlateEditor.module.scss"
import {
    type LinkFloatingToolbarState,
    FloatingLinkUrlInput,
    useFloatingLinkEdit,
    useFloatingLinkEditState,
    useFloatingLinkInsert,
    useFloatingLinkInsertState, LinkOpenButton,
} from '@udecode/plate-link/react';

export function FloatingLinkEditor(props: {
    state?: LinkFloatingToolbarState,
}) {
    const {state} = props;

    const floatingOptions: UseVirtualFloatingOptions = useMemo(() => {
        return {
            placement: "bottom-start",
        };
    }, []);

    const insertState = useFloatingLinkInsertState({
        ...state,
        floatingOptions: {
            ...floatingOptions,
            ...state?.floatingOptions,
        },
    });
    const {
        hidden,
        props: insertProps,
        ref: insertRef,
        textInputProps,
    } = useFloatingLinkInsert(insertState);
    const editState = useFloatingLinkEditState({
        ...state,
        floatingOptions: {
            ...floatingOptions,
            ...state?.floatingOptions,
        },
    });
    const {
        editButtonProps,
        props: editProps,
        ref: editRef,
        unlinkButtonProps,
    } = useFloatingLinkEdit(editState);

    if (hidden) return null;

    const input = <div className={styles.linkInputContainer}>
        <div className={styles.row}>
            <div>
                <FontAwesome prefix={"fas"} name={"fa-link"} />
            </div>

            <FloatingLinkUrlInput placeholder="Paste link" />
        </div>

        <div className={styles.row}>
            <div>
                <FontAwesome prefix={"fas"} name={"fa-align-left"} />
            </div>
            <input
                placeholder="Text to display"
                {...textInputProps}
            />
        </div>
    </div>

    const editContent = editState.isEditing ? (
        input
    ) : (
        <div className={styles.linkEditContainer}>
            <div className={styles.toolbarGroup}>
                <button
                    className={styles.button}
                    type="button"
                    {...editButtonProps}
                >
                    Edit link
                </button>
            </div>
            <div className={styles.toolbarGroup}>
                <LinkOpenButton className={styles.button}>
                    <FontAwesome prefix={"fas"} name={"fa-external-link-alt"} />
                </LinkOpenButton>
            </div>
            <div className={styles.toolbarGroup}>
                <button
                    className={styles.button}
                    type="button"
                    {...unlinkButtonProps}
                >
                    <FontAwesome name={'fa-unlink'} prefix={'fas'}/>
                </button>
            </div>
        </div>
    );

    return <>
        <div
            ref={insertRef}
            className={styles.floatingLinkToolbar}
            {...insertProps}
        >
            {input}
        </div>
        <div
            className={styles.floatingLinkToolbar}
            ref={editRef}
            {...editProps}
        >
            {editContent}
        </div>
    </>
}
